import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { ApiService } from '../../api/api.service';
import { LoggerService } from '../../logger-services/logger.service';
import { ConfigurationService } from '../../configuration/configuration.service';
import { PresignDownloadUrlResponse } from '../../../app/models/file-upload.models';
import { TokenService } from '../../../shared/services/token/token.service';

@Injectable({
  providedIn: 'root'
})
export class DownloadPresignedurlService {
  private readonly apiService = inject(ApiService);
  private readonly loggerService = inject(LoggerService);
  private readonly configService = inject(ConfigurationService);
  private readonly tokenService = inject(TokenService);
  
  /**
   * Gets the configuration data from the configuration service
   */
  private get configdata(): any {
    return this.configService.configData;
  }

  /**
   * Gets presigned download URL for a document by its ID
   * @param documentId - Document ID obtained from save-to-myfiles endpoint
   * @returns Observable containing presigned download URL response
   */
  getPresignedDownloadUrl(documentId: number): Observable<PresignDownloadUrlResponse> {
    try {
      let endpoint = this.apiService.getApiUrlFromConfig('GENERATE_PRESIGNED_DOWNLOAD');
      // Replace {documentId} placeholder with actual documentId
      endpoint = endpoint.replace('{documentId}', documentId.toString());
      return this.apiService.get<PresignDownloadUrlResponse>(
        endpoint,
        this.tokenService.getAccessToken(),
        undefined,
        'URF',
        `${this.configdata.docFileUploadUrl}`
      ).pipe(
        catchError((error: HttpErrorResponse) => {
          this.loggerService.logError(this.formatError(error), "getPresignedDownloadUrl");
          return throwError(() => error);
        })
      );
    } catch (error: any) {
      this.loggerService.logError(this.formatError(error), "getPresignedDownloadUrl");
      return throwError(() => error);
    }
  }

  /**
   * Formats error object for logging
   * @param error - The error object
   * @returns Formatted error object
   */
  private formatError(error: any): any {
    if (error instanceof HttpErrorResponse) {
      return {
        message: error.message,
        status: error.status,
        statusText: error.statusText,
        url: error.url,
        error: error.error
      };
    }
    return error;
  }
}
